import settings from '@/settings'

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/tiposveiculo/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let get = (headers) => {
  return fetch(`${settings.apetrusApi}/tiposveiculo/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let update = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/tiposveiculo/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let deleteveiculo = (id, headers) => {
  return fetch(`${settings.apetrusApi}/tiposveiculo/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  insert,
  get,
  update,
  deleteveiculo
}
